__turbopack_context__.v({
  "reviewModal": "ProductReviewsModals-module-scss-module__HcgsYq__reviewModal",
  "reviewModalRoot": "ProductReviewsModals-module-scss-module__HcgsYq__reviewModalRoot",
  "reviewSuccessContent": "ProductReviewsModals-module-scss-module__HcgsYq__reviewSuccessContent",
  "reviewSuccessIcon": "ProductReviewsModals-module-scss-module__HcgsYq__reviewSuccessIcon",
  "reviewSuccessModal": "ProductReviewsModals-module-scss-module__HcgsYq__reviewSuccessModal",
});
